import { error } from "console";
import { AuditQuestion } from "../models/AuditQuestion";
import { Audit } from "../models/Audit";
import { AuditDetail } from "../models/AuditDetail";
import { Section } from "../models/Section";
import axios, { AxiosRequestConfig } from "axios";
import { saveAs } from "file-saver";
import { PolicyType } from "../models/PolicyType";
import { AuditAnswer } from "../models/AuditAnswer";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const insertAnswer = async (answer: AuditAnswer) => {
  const response = await fetch(`${API_BASE_URL}/AuditAnswer/Insert`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(answer),
  });

  return response;
};

const updateAnswer = async (answer: AuditAnswer) => {
  const response = await fetch(`${API_BASE_URL}/AuditAnswer/Update`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(answer),
  });

  return response;
};

const deleteAnswer = async (answer: AuditAnswer) => {
  const response = await fetch(`${API_BASE_URL}/AuditAnswer/Delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(answer),
  });

  return response;
};

const AnswerService = {
  insertAnswer,
  updateAnswer,
  deleteAnswer,
};

export default AnswerService;
